<div class="spinner-overlay">
  <div class="spinner-container m-auto">
    <mat-spinner class="m-auto"></mat-spinner>
    <h3>{{messageText}}</h3>
  </div>
</div>
